<template>
  <Modal size="md" :is-open="isOpen" @close="$emit('close')">
    <HelperViewContextual
      class="helper"
      icon="BC0020"
      :title="helperData.title"
      :description="helperData.description"
    />
    <ListDisplay
      v-if="props.type !== EBlockTypes.REGULATORY_UPDATE"
      title="Público alvo"
      :value="listValue"
    />
    <template
      v-if="props.type === EBlockTypes.REGULATORY_UPDATE"
      #buttonContainer
    >
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            label="Atualizar cadastro"
            @click="goToRegulatoryUpdate"
          />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  Modal,
  HelperViewContextual,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { EBlockTypes } from '@/modules/catalog/types/block-types';

const router = useRouter();

interface Props {
  isOpen: boolean;
  type: string;
}
const props = defineProps<Props>();

const helperData = computed(() => {
  if (props.type === EBlockTypes.REGULATORY_UPDATE) {
    return {
      title: 'Atualize seu cadastro',
      description:
        'Não é possível investir quando há uma atualização cadastral pendente.'
    };
  }

  return {
    title: 'Perfil incompatível',
    description:
      'Não é possível investir no produto, pois ele possui um público alvo que não se enquadra no seu perfil de investidor.'
  };
});

const listValue = computed(() => {
  const mapper: { [key: string]: string } = {
    [EBlockTypes.QUALIFIED_INVESTOR]: 'Investidor qualificado',
    [EBlockTypes.PROFESSIONAL_INVESTOR]: 'Investidor profissional'
  };

  return mapper[props.type];
});

function goToRegulatoryUpdate() {
  router.push({ name: 'regulatoryUpdateAnnouncement' });
}
</script>

<style lang="less" scoped>
:deep(.base-modal--wrapper) {
  max-width: 592px !important;
}

:deep(.modal-content) {
  padding: 0 @size-spacing-x1000 @size-spacing-x1000;
}

:deep(.helper-view) {
  max-width: none;
}

.list-display {
  margin-top: @size-spacing-x800;
  border-top: @size-border-x400 solid @divider-primary;
}

:deep(.list-display__content) {
  padding-top: @size-spacing-x450;
}
</style>
